import {CSSProperties, ReactNode, useContext} from 'react';
import Header, {IProps as IHeaderProps} from './Header';
import HeaderGradientV4 from './HeaderGradientV4';
import {getBgCN} from '../constant';
import {PageAppContext, PageContext} from '../context';
import useTypedSelector from '../hook/useTypedSelector';
import {HEADER_HEIGHT, SUB_TAB_HEIGHT_V4} from '../scss/util/variable';

export interface IProps extends Omit<IHeaderProps, 'ref' | 'onClick'> {
  showGradient?: boolean;
  showHeader?: boolean;
  showTitle?: boolean;
  gradientStyle?: CSSProperties;
  wrapperClassName?: string;
  hasTopSpace?: boolean;
  tabElement?: ReactNode;
  onClickHeaderButton?: () => void;
}

export default function PageContainerV4({
  title,
  children,
  showGradient = true,
  showHeader = true,
  showTitle = true,
  wrapperClassName,
  gradientStyle,
  hasTopSpace = true,
  tabElement,
  onClickHeaderButton,
  ...rest
}: IProps) {
  const showTabElement = showHeader && !!tabElement;
  const {title: pageContextTitle} = useContext(PageContext);
  const {title: pageAppContextTitle} = useContext(PageAppContext);
  const pageTitle = title || pageContextTitle || pageAppContextTitle;

  const currentPage = useTypedSelector(state => state.common.layoutProps.page);

  return (
    <>
      <div className="absolute top-0 left-0 w-full z-navigationBar">
        {showHeader && showGradient && (
          <HeaderGradientV4
            style={showTabElement ? GRADIENT_STYLE : gradientStyle}
          />
        )}
        {showHeader && (
          <Header
            buttonIcon="back"
            onClick={onClickHeaderButton}
            {...rest}
            title={showTitle ? pageTitle : undefined}
          />
        )}
        {showTabElement && <div className="mt-header-height">{tabElement}</div>}
      </div>
      {hasTopSpace && (
        <>
          {showHeader && <div className="h-header-height" />}
          {showTabElement && <div className="h-sub-tab-height-v4" />}
        </>
      )}
      <div className={cn(wrapperClassName, getBgCN(currentPage))}>
        {children}
      </div>
    </>
  );
}

const GRADIENT_STYLE = {height: `${HEADER_HEIGHT + SUB_TAB_HEIGHT_V4}px`};
